import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';

export interface InputDialogResult {
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrl: './input-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatDialogActions,
    MatButton,
    MatCheckbox,
  ],
})
export class InputDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<InputDialogComponent>>(MatDialogRef);

  data = inject<{
    title: string | undefined;
    description: string;
    type: string | undefined;
    placeholder: string | undefined;
    label: string | undefined;
    close_button_text: string;
    checkbox_label?: string;
    checkbox_default?: boolean;
  }>(MAT_DIALOG_DATA);

  value: string = '';
  checkboxChecked = false;

  ngOnInit(): void {
    this.checkboxChecked = this.data.checkbox_default ?? false;
  }

  submit(): void {
    if (this.data.checkbox_label) {
      this.dialogRef.close({ value: this.value, checked: this.checkboxChecked });
      return;
    }

    this.dialogRef.close(this.value);
  }
}
